export const CHATBOT_WIDGET_IFRAME_WINDOW_ID =
  'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window';
export const CHATBOT_LETS_CHAT_CONTAINER_CLASS_NAME =
  'lets-chat-link-container';
export const CHATBOT_LETS_CHAT_LINK_CLASS_NAME = 'lets-chat-link';
export const CHATBOT_LETS_CHAT_LINK_CLASS_NAME_LARGE = 'lets-chat-link-large';
export const CHATBOT_LETS_CHAT_LINK_CLASS_NAME_SMALL = 'lets-chat-link-small';
export const CHATBOT_LETS_CHAT_LINK_ID = 'lets-chat-link-id';
export const APP_NAME = 'IB';
export const BIB_BOT_NAME = 'business_banking_redi';
export const IB_BOT_NAME = 'pca_redi';
